import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    groupPaper: {
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main,
        border: "solid 1px",
        boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
        height: "100%"
    },
    groupPaper50: {
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main,
        border: "solid 1px",
        boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
        height: "50%",
        marginBottom: 5
    },
    filterRow: {
        display: 'flex',
        flexWrap: "wrap",
        flexDirection: 'row',
        alignItems: 'center'
    },
    smallPanelHeader: {
        ...theme.typography.h5,
        color: theme.palette.text.secondary,
        display: 'flex',
        justifyContent: "center"
    },
    formControl: {
        minWidth: 180,
        margin: theme.spacing(1),
        color: theme.palette.common.white
    },
    root: {
        marginTop: 15,
        display: 'flex',
        alignItems: "center",
        justifyContent: "center"
    },
    image: {
        display: 'flex',
        alignItems: "center",
        justifyContent: "center",
        marginTop: 20,
        marginBottom: 20,
        maxWidth: "50%",
        maxHeight: "50%",
        margin: "0 auto"
    }
}));

export {useStyles};